/* A resize event which can be used globally */
function screenSizer(wait) {
  const elements = document.querySelectorAll('.footer-block__details-content');
  let lastIsSmallScreen = window.innerWidth <= 749;

  function updateSize() {
    const isSmallScreen = window.innerWidth <= 749;
    if (isSmallScreen !== lastIsSmallScreen) {
      elements.forEach(element => {
        const shouldOpen = !isSmallScreen;
        element.setAttribute('aria-expanded', shouldOpen.toString());
        if (shouldOpen) {
          element.setAttribute('open', '');
        } else {
          element.removeAttribute('open');
        }
      });
      lastIsSmallScreen = isSmallScreen;
    }
  }

  const debouncedUpdateSize = debounce(updateSize, wait);
  window.addEventListener('resize', debouncedUpdateSize);
  
  // Ensure elements are open by default on desktop
  elements.forEach(element => {
    if (!lastIsSmallScreen) {
      element.setAttribute('aria-expanded', 'true');
      element.setAttribute('open', '');
    }
  });

  updateSize();
}

screenSizer(200);